import React from 'react';
import { DownArrow1 as DownArrowIcon, UpArrow as UpArrowIcon } from 'src/assets/images';
import './arrow-button.scss';

export enum ArrowDirection {
  Up = 'UP',
  Down = 'DOWN',
}

type Props = {
  text: string;
  arrowDirection: ArrowDirection;
  onClick: () => void;
  style?: string;
  automationId?: string;
  arrowDownIcon?: string;
  arrowUpIcon?: string;
};

/**
 *  Displays text with an arrow icon next to it
 *  @param props.text the text to be displayed
 *  @param props.arrowDirection direction of the arrow
 *  @param props.onClick callback to be fired when the component is clicked
 *  @param props.style optional parameter to inject a class name
 *  @param props.automationId
 **/
const ArrowButton: React.FC<Props> = (props: Props) => {
  return (
    <>
      <div
        className={`ArrowButton is-flex is-justify-content-space-between ${
          props.style ? props.style : ''
        }`}
        onClick={props.onClick}
        automationid={props.automationId}
      >
        {props.text}
        <img
          className="is-block"
          src={
            props.arrowDirection === ArrowDirection.Up
              ? props.arrowUpIcon || UpArrowIcon
              : props.arrowDownIcon || DownArrowIcon
          }
        />
      </div>
    </>
  );
};

export default ArrowButton;
